module.exports = __webpack_public_path__ + "img/footer.73bd71c9.jpg";